var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-count"},[_c('div',{staticClass:"star"}),_c('div',{staticClass:"rate"},[_vm._v(_vm._s(_vm.num)+"/100")]),_c('img',{staticClass:"tip",attrs:{"src":require("@/assets/zs_imgs/ck-xwh.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }